import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { CourseService } from 'src/app/services/course/course.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AddCoursePlaylistComponent } from '../../course-playlist/add-course-playlist/add-course-playlist.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-add-notes',
  templateUrl: './add-notes.component.html',
  styleUrls: ['./add-notes.component.scss']
})
export class AddNotesComponent {
  files: File[] = [];
  public addForm!: FormGroup;
  public isSpinnerLoading: boolean = false;
  private employeeId!: string;
  constructor(private recruiterService: RecruiterService, private fb: FormBuilder, private appService: AppService, private commonService: CommonService,
    public dialogRef: MatDialogRef<AddCoursePlaylistComponent>, private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public dialogData: any,) { }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.

    this.addForm = this.fb.group({
      "tit": ['', [Validators.required, Validators.maxLength(60)]],
      "notes": ['', Validators.required],
      "file": "",
    })
    if (this.dialogData) {
      if (this.dialogData['em_i']) {
        this.employeeId = this.dialogData['em_i'];
      }
      if (this.dialogData['id']) {
        this.addForm.get('tit')?.setValue(this.dialogData['tit']);
        this.addForm.get('notes')?.setValue(this.dialogData['notes']);
      }
    }
  }
  get getControls() {
    return this.addForm.controls;
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  onSelect(event: any) {
    this.files = []
    this.files.push(...event.addedFiles);
    var reader = new FileReader();
    reader.readAsDataURL(event.addedFiles[0]);
    reader.onload = (_event) => {
    }
  }
  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }
  onSubmit() {
    if (this.addForm.valid) {
      this.isSpinnerLoading = true;
      let formData = new FormData();
      formData.append('em_i', this.employeeId);
      formData.append("tit", this.addForm.get('tit')?.value)
      formData.append("notes", this.addForm.get('notes')?.value)
      if (this.files[0]) {
        formData.append("file", this.files[0])
      }
      this.spinner.show()
      if (this.dialogData.id) {
        formData.append("id", this.dialogData['id'])
        this.recruiterService.editNotes(formData).subscribe({
          next: (success: any) => {
            if (success.status == 200) {
              this.spinner.hide()
              this.appService.showToastMessage('success', success.msg)
              this.dialogRef.close({ data_added: true })
            }
          },
          error: (error: any) => {
            this.spinner.hide()
            this.commonService.handleError(error)
          }
        })
      }
      else {
       
        this.recruiterService.addNotes(formData).subscribe({
          next: (success: any) => {
            if (success.status == 200) {
              this.spinner.hide()
              this.appService.showToastMessage('success', success.msg)
              this.dialogRef.close({ data_added: true })
            }
          },
          error: (error: any) => {
            this.spinner.hide()
            this.commonService.handleError(error)
          }
        })
      }
    } else {
      this.addForm.markAllAsTouched()
    }
  }
}